import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';

export default action('showFindFavoritesPicker')(function showFindFavoritesPicker(
    shouldShow: boolean
) {
    store.mailFavoritesViewState.shouldShowFindFavoritesPicker = shouldShow;
});
